import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/home/ty_dh_icon.png';
import _imports_1 from '@/assets/images/home/ty_yx_icon.png';
import _imports_2 from '@/assets/images/home/ty_dz_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-a0b21bda"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "footer-nav"
};
const _hoisted_2 = {
  class: "nav-c"
};
const _hoisted_3 = {
  class: "footer-nav-resoult"
};
const _hoisted_4 = {
  class: "tit"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "openLi"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "tit"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_10 = {
  class: "phone"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_13 = {
  key: 0,
  class: "qr-code"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tit"
}, "微信公众号", -1));

const _hoisted_15 = {
  class: "copyright"
};
const _hoisted_16 = {
  class: "copyright-txt"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("      ");

const _hoisted_18 = {
  class: "record",
  href: "https://beian.miit.gov.cn/?spm=a2c4g.11186623.0.0.1c9544b7EaFYC8#/Integrated/index",
  target: "_blank"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productBarList, item => {
    return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
      onClick: $event => _ctx.changeMenu(item, item)
    }, _toDisplayString(item.name), 9, _hoisted_5)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, ico => {
      return _openBlock(), _createElementBlock("ul", _hoisted_6, [_createElementVNode("li", null, [_createElementVNode("span", {
        onClick: $event => _ctx.changeMenu(item, ico)
      }, _toDisplayString(ico.name), 9, _hoisted_7)])]);
    }), 256))]);
  }), 256)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.configData.companyName), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.configData.contactNumber), 1)]), _createElementVNode("li", null, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(_ctx.configData.email), 1)]), _createElementVNode("li", null, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(_ctx.configData.companyAddress), 1)])])]), _ctx.configData.wechatQrCode ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_image, {
    src: _ctx.imgUrl(_ctx.configData.wechatQrUrl),
    lazy: "",
    fit: "cover"
  }, null, 8, ["src"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("p", null, _toDisplayString(_ctx.configData.crinfoEn), 1), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.configData.crinfoCn), 1), _hoisted_17, _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.configData.recordNumber), 1)])])])])])]);
}